import { SIZES } from '../types/index';

const initialState = [];

export default function(state = initialState, action) {

    switch(action.type) {

        case SIZES: 

            return action.payload;

        default:

            return state;

    }

};